import Modal from 'react-modal';

export default function ComingSoonModal({ isOpen, onClose, title = 'Feature' }) {
    return (
        <Modal
            isOpen={isOpen}
            onRequestClose={onClose}
            contentLabel="Coming Soon"
            style={{
                overlay: { backgroundColor: 'rgba(0,0,0,0.5)', zIndex: 1100, display: 'flex', alignItems: 'center', justifyContent: 'center' },
                content: {
                    position: 'relative', inset: 'unset',
                    width: '100%', maxWidth: '360px',
                    borderRadius: '14px', padding: '0',
                    border: 'none', boxShadow: '0 8px 32px rgba(0,0,0,0.18)',
                    overflow: 'hidden', fontFamily: 'Inter, sans-serif',
                    textAlign: 'center',
                },
            }}
        >
            <div style={{ background: 'linear-gradient(135deg, #074870 0%, #0c6fad 100%)', padding: '24px 20px 20px' }}>
                <div style={{ fontSize: '40px', marginBottom: '8px' }}>🚀</div>
                <h2 style={{ margin: 0, fontSize: '18px', fontWeight: '700', color: '#fff' }}>{title}</h2>
            </div>

            <div style={{ padding: '24px 20px' }}>
                <div style={{
                    display: 'inline-block',
                    backgroundColor: '#e0f0ff', color: '#074870',
                    borderRadius: '20px', padding: '4px 14px',
                    fontSize: '12px', fontWeight: '600',
                    letterSpacing: '0.5px', marginBottom: '14px',
                }}>
                    FUTURE ENHANCEMENT
                </div>
                <p style={{ fontSize: '14px', color: '#4a5568', lineHeight: '1.6', margin: '0 0 20px' }}>
                    This feature is currently under development and will be available in a future release.
                </p>
                <button
                    onClick={onClose}
                    style={{
                        backgroundColor: '#074870', color: '#fff',
                        border: 'none', borderRadius: '8px',
                        padding: '10px 28px', fontSize: '14px',
                        fontWeight: '600', cursor: 'pointer',
                        fontFamily: 'Inter, sans-serif',
                    }}
                >
                    Got it
                </button>
            </div>
        </Modal>
    );
}
